"use client";
import { Box, SimpleGrid, GridItem } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import OneMindFeatures from "@/components/oneMindFeatures";
import AdvantageCardList from "@/components/advantageCard";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import SafeView from "@/components/safeView";
import { HEADING_CONSTANTS, FEATURES_CONSTANTS, USE_CASES_CONSTANTS } from "./constants";

const SolutionComponent = () => {
  const headingVariant = useHeadingVariant();
  const { title, desc } = HEADING_CONSTANTS;
  return (
    <Box>
      <SafeView>
        <Heading as="h1" variant={headingVariant} textAlign={"center"} mt={20}>
          {title}
        </Heading>
        <Balancer>
          <Text variant={"label1"} color={"text.100"} textAlign={"center"} my={12}>
            {desc}
          </Text>
        </Balancer>
      </SafeView>
      <SimpleGrid
        columns={{ base: 1, sm: 1, md: 5 }}
        gap={{ base: 8, md: 0 }}
        bgColor={"#EDF2F7"}
        border="1px solid #E2E8F0"
        boxShadow={"xl"}
      >
        <GridItem colSpan={{ base: 1, sm: 1, md: 3 }} alignSelf={"center"}>
          <OneMindFeatures {...FEATURES_CONSTANTS} />
        </GridItem>
        <GridItem
          colSpan={{ base: 1, sm: 1, md: 2 }}
          py={6}
          pr={{
            base: "1rem",
            sm: "2rem",
            lg: "3rem",
            xl: "5rem",
            "2xl": "calc(calc(100vw - 1600px) / 2)",
            // "3xl": "calc(calc(100vw - 1800px) / 2)",
          }}
          pl={{
            base: "1rem",
            sm: "2rem",
            // md: "0",
          }}
          bg="white"
        >
          <AdvantageCardList
            columns={{ base: 2 }}
            items={USE_CASES_CONSTANTS.list}
            bgColor="#EDF2F7"
            title={USE_CASES_CONSTANTS.title}
          />
        </GridItem>
      </SimpleGrid>
    </Box>
  );
};

export default SolutionComponent;
